import i18n from '@/i18n';

export const callFirst = (fn, larg) => (...rest) => fn.call(this, larg, ...rest);

/* eslint-disable no-underscore-dangle */
export const sanitizeFormValues = values => Object.keys(values).reduce((acc, key) => {
  const field = values[key];
  if (field !== undefined && field !== null) {
    if (typeof field === 'object' && !Array.isArray(field)) {
      /**
        * We do this because Ant Design pickers (date picker, time picker...) return a
        * moment objects instead of actual dates when used in forms
        */
      acc[key] = field._isAMomentObject ? field.valueOf() : sanitizeFormValues(field);
    } else {
      acc[key] = field;
    }
  }
  return acc;
}, {});
/* eslint-enable */

export const formatOptions = (options = []) => options.map((option, index) => ({
  ...option,
  label: `${option.label} (${option.value}min)`,
  value: `${index}__${option.value}`,
}));

const normalizeRegexp = /\d__(?<value>-?\d+.?\d*)$/;

export const normalizeFormData = (values) => {
  const getValue = (val) => {
    if (normalizeRegexp.test(val)) {
      // not sure if parseFloat is needed
      return parseFloat(normalizeRegexp.exec(val).groups.value);
    }
    return val;
  };

  return Object.assign({}, values, {
    area: getValue(values.area),
    spec: Object.keys(values.spec).filter(key => values.spec[key]).reduce(
      (acc, val) => {
        acc[val] = getValue(values.spec[val]);
        return acc;
      }, {},
    ),
  });
};

export const getProp = (object, path, defaultVal) => {
  /* eslint-disable-next-line no-underscore-dangle */
  const _path = Array.isArray(path) ? path : path.split('.').filter(i => i.length);

  if (!_path.length) {
    return object === undefined ? defaultVal : object;
  }

  return getProp(object[_path.shift()], _path, defaultVal);
};

export const formatTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes - (hours * 60));
  return `${hours}${i18n.t('common.hourShort')} ${mins}${i18n.t('common.minutesShort')}`;
};

export const orderByKeys = (obj, keys) => {
  const objCopy = { ...obj };
  const sortedObj = {};
  keys.forEach((key) => {
    sortedObj[key] = objCopy[key];
    /* eslint-disable-next-line no-param-reassign */
    delete objCopy[key];
  });

  // Insert all the fields not specified in `keys` array at the end of the sorted object
  return Object.assign(sortedObj, objCopy);
};

export const maskCardNumber = last4 => `•••• •••• •••• ${last4}`;
